
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/konkursy/[slug]",
      function () {
        return require("private-next-pages/konkursy/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/konkursy/[slug]"])
      });
    }
  